import { useTranslation } from "react-i18next";
import RecordingModeTiles from "../recording/RecordingModeTiles";
import { ALL_MODES } from "../../utils/recordingModes";

export function MeasurePanel({
  onClose,
  firstRunByVariant,
  isPermitted = () => false,
}) {
  const { t } = useTranslation("common");
  const showRecordings = ALL_MODES.some((mode) => isPermitted(mode));

  return (
    <div className="flex w-full max-w-lg flex-col gap-4 md:pt-4">
      <div className="flex w-full min-h-[44px] items-center justify-between gap-3">
        <h2 className="subtitle-text">{t("navBar.measure", "Measure")}</h2>
        <button
          type="button"
          className="small-outlined-button !min-h-0 !inline-flex !min-w-fit !flex-row !items-center !justify-center !gap-1 whitespace-nowrap group"
          onClick={onClose}
          aria-label={t("close", "Close")}
        >
          <span
            className="material-symbols-outlined text-[24px] text-primary hover:!text-greyscale-1 group-hover:text-greyscale-1"
            aria-hidden="true"
          >
            close
          </span>
          <span className="leading-none">{t("close", "Close")}</span>
        </button>
      </div>

      {showRecordings ? (
        <section className="flex w-full flex-col gap-3">
          <RecordingModeTiles
            firstRunByVariant={firstRunByVariant}
            isPermitted={isPermitted}
          />
        </section>
      ) : null}
    </div>
  );
}
